import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import TextField from '@material-ui/core/TextField/TextField';
import clsx from 'clsx';
import { connect } from 'react-redux';
import SecondaryScreen from '../components/screens/SecondaryScreen';
import { withFormik } from 'formik';
import { withRouter } from 'react-router';
import { screens } from '../styles/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import classNames from 'classnames';

const styles = (theme) => ({
    layout: {
        minWidth: '400px',
        maxWidth: '400px',
        padding: '30px',
        marginTop: '30px',
        [theme.breakpoints.down(screens.mobile)]: {
            minWidth: '100%',
            maxWidth: '100%',
            flex: 1,
            padding: '30px',
            marginTop: '0px',
        },
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
    },
    error: {
        color: 'rgba(255,0,0,1)',
        fontSize: '14px',
        letterSpacing: '0.17px',
        lineHeight: '16px',
        paddingBottom: '15px',
    },
    text: {
        color: 'rgba(142,142,147,1)',
        fontSize: '14px',
        letterSpacing: '0.17px',
        lineHeight: '16px',
    },
    checkLabel: {
        color: 'rgba(142,142,147,1)',
        fontSize: '14px',
        letterSpacing: '0.17px',
        lineHeight: '16px',
    },
    check: {
        '&$checked': {
            color: 'rgba(0,84,255,1)',
        },
    },
    checked: {},
    titleBlock: {
        marginBottom: '20px',
    },
    textBlock: {
        marginBottom: '30px',
    },
    loginButton: {
        marginTop: '30px',
        minHeight: '60px',
        maxHeight: '60px',
        width: '100%',
        borderRadius: '4px',
        backgroundColor: 'rgba(0,84,255,1)',
        '&:hover': {
            backgroundColor: '#004EEE',
        },
        boxShadow: '0 2px 4px 0 rgba(5,33,81,0.07)',
        color: theme.palette.text.primaryInverse,
        fontSize: '18px',
        textTransform: 'none',
    },
});

class PasswordReset extends React.Component {
    render() {
        const { classes, values, errors, touched, handleChange, handleBlur, handleSubmit } =
            this.props;

        return (
            <SecondaryScreen title={'Belépés a kárriasztási rendszerbe'}>
                <div className={clsx(classes.layout)}>
                    <form className={classes.form} onSubmit={handleSubmit}>
                        <Typography variant="h6" className={classes.titleBlock}>
                            Elfelejtette a jelszavát vagy először jár itt?
                        </Typography>
                        <p>
                            <Typography variant="body2">
                                Belépéshez kérjük adja meg regisztrált email címét vagy
                                telefonszámát. A megadott elérhetőségére egy linket küldünk Önnek,
                                amelynek segítségével be tud lépni a kárriasztási felületre.
                            </Typography>
                        </p>
                        <br />
                        <div className={classes.text}>Email cím</div>
                        <br />
                        <TextField
                            name="email"
                            autoFocus={true}
                            autoComplete={'email'}
                            error={!!(touched.email && errors.email)}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                            variant="outlined"
                            helperText={touched.email && errors.email}
                        />
                        <br />
                        <br />
                        <br />
                        <div className={classes.text}>Telefonszám</div>
                        <br />
                        <TextField
                            name="phone"
                            autoComplete={'phone'}
                            error={!!(touched.phone && errors.phone)}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.phone}
                            variant="outlined"
                            helperText={touched.phone && errors.phone}
                        />
                        <br />
                        <br />
                        <Button className={classNames(classes.loginButton)} type="submit">
                            Belépési link kérése
                        </Button>
                    </form>
                </div>
            </SecondaryScreen>
        );
    }
}

PasswordReset.propTypes = {
    classes: PropTypes.object.isRequired,
};

const formikOptions = {
    mapPropsToValues: () => ({ username: '', password: '' }),
    validate: (values, props) => {
        let errors = {};
        const requiredFields = ['username'];
        requiredFields.forEach((field) => {
            if (!values[field]) {
                errors[field] = 'Kötelező kitölteni!';
            }
        });
        if (values.username && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.username)) {
            errors.username = props.t('Form.InvalidEmail');
        }

        return errors;
    },
    handleSubmit: (values, { setSubmitting, props }) => {
        // const { username } = values;
        // props.dispatch(loginActions.passwordReset(username));
        // props.history.push(ROUTES.HOME);
        setSubmitting(false);
    },
    displayName: 'BasicForm',
};

function mapStateToProps(state) {
    return {
        /*
                login: state.login,
                error: state.error.error,
        */
    };
}

export default withRouter(
    connect(mapStateToProps)(withFormik(formikOptions)(withStyles(styles)(PasswordReset)))
);
